<!-- Layout global à l'application - Menu de 'gauche' -->

<mat-toolbar id="mainToolbar">
    <mat-icon class="menu-icon WancomIcon" *ngIf="isDeviceisDesktop" (click)="editMenuExpandContext()"> menu </mat-icon>
    <mat-icon svgIcon="logoWanviewWhite" (click)="sendTo('park', 'tv'); goToHome()" class="logoWanview"></mat-icon>
    <p class="pageTitle">{{ title$ | async }}</p>
    <span style="flex: 1 1 auto"></span>
    <!-- Bouton de tuto - DIASBLED -->
    <button
        style="display: none"
        *ngIf="isTvIconSelected"
        (click)="wvGuidedTour$.launchParkTour(true)"
        matTooltip="Découvir ma page 'Parc'"
        mat-icon-button
    >
        <mat-icon style="color: white">help</mat-icon>
    </button>
</mat-toolbar>

<wnvw-waiting></wnvw-waiting>
<mat-sidenav-container (window:resize)="onResize($event)" id="container">
    <mat-sidenav
        *ngIf="menuContext$.value == true"
        [ngClass]="[
            isDeviceisDesktop ? 'desktopNavigation' : 'mobileNavigation',
            menuExpandContext$.value == true ? 'explicitMenu' : 'iconMenu',
        ]"
        #sideNav
        mode="side"
        opened
    >
        <mat-nav-list>
            <!-- Page 'Parc' - liste des écrans -->
            <span
                id="parkLayout"
                [ngClass]="[
                    isTvIconSelected == true && isDeviceisDesktop == true ? 'iconSelected' : '',
                    isTvIconSelected == true && isDeviceisDesktop == false ? 'mobileIconSelected' : '',
                    !userService.isLogged() ? 'iconDisabled' : '',
                ]"
                (click)="sendTo('park', 'tv')"
            >
                <a>
                    <mat-icon class="navigationIcon">tv</mat-icon>
                    <span *ngIf="menuExpandContext$.value == true && isDeviceisDesktop">Ecrans</span>
                </a>
            </span>

            <!-- MARK: Page 'Timeline' -->
            @if (isDeviceisDesktop) {
                <span
                    [ngClass]="[
                        isTimelineIconSelected == true && isDeviceisDesktop == true ? 'iconSelected' : '',
                        isTimelineIconSelected == true && isDeviceisDesktop == false ? 'mobileIconSelected' : '',
                        !userService.isLogged() ? 'iconDisabled' : '',
                    ]"
                    (click)="sendTo('timeline', 'timeline')"
                >
                    <a>
                        <mat-icon class="navigationIcon material-icons-outlined">timeline</mat-icon>
                        @if (menuExpandContext$.value == true && isDeviceisDesktop) {
                            <span>Planning</span>
                            <span id="newTag">Nouveau !</span>
                        }
                    </a>
                </span>
            }

            <!-- page 'Spot' - Liste des spots -->
            <span
                id="spotLayout"
                *ngIf="isDeviceisDesktop"
                [ngClass]="[
                    isSpotIconSelected == true && isDeviceisDesktop == true ? 'iconSelected' : '',
                    isSpotIconSelected == true && isDeviceisDesktop == false ? 'mobileIconSelected' : '',
                    !userService.isLogged() ? 'iconDisabled' : '',
                ]"
                (click)="sendTo('spots', 'spot')"
            >
                <a>
                    <mat-icon class="navigationIcon">play_circle_outline</mat-icon>
                    <span *ngIf="menuExpandContext$.value == true && isDeviceisDesktop">Spots</span>
                </a>
            </span>

            <!-- Page 'Compte' - profil utilisateur -->
            <span
                *ngIf="isDeviceisDesktop"
                [ngClass]="[
                    isAccountIconSelected == true && isDeviceisDesktop == true ? 'iconSelected' : '',
                    isAccountIconSelected == true && isDeviceisDesktop == false ? 'mobileIconSelected' : '',
                ]"
                (click)="userService.isLogged() ? sendTo('account-detail', 'account') : logIn()"
                class="accountButton"
            >
                <a>
                    <mat-icon>account_circle</mat-icon>
                    <span *ngIf="menuExpandContext$.value == true && isDeviceisDesktop">
                        {{ userService.isLogged() ? 'Compte' : 'Se Connecter' }}
                    </span>
                </a>
            </span>

            <!-- Page 'Médiathèque' -->
            <!-- <span
                *ngIf="isDeviceisDesktop && userService.hasRight('CanSeeLibrary')"
                [ngClass]="[
                    isMediaIconSelected == true && isDeviceisDesktop == true ? 'iconSelected' : '',
                    isMediaIconSelected == true && isDeviceisDesktop == false ? 'mobileIconSelected' : '',
                ]"
                (click)="sendTo('medias', 'media')"
            >
                <a>
                    <mat-icon class="navigationIcon">collections</mat-icon>
                    <span *ngIf="menuExpandContext$.value == true && isDeviceisDesktop">Médiathèque</span>
                </a>
            </span> -->

            <!-- Page 'Tickets' - Liste des tickets -->
            <span
                *ngIf="isDeviceisDesktop && userService.hasRight('CanSeeTicketOnScreen')"
                [ngClass]="[
                    isTicketIconSelected == true && isDeviceisDesktop == true ? 'iconSelected' : '',
                    isTicketIconSelected == true && isDeviceisDesktop == false ? 'mobileIconSelected' : '',
                ]"
                (click)="sendTo('tickets', 'ticket')"
            >
                <a>
                    <span class="material-icons-outlined navigationIcon">build</span>
                    <span *ngIf="menuExpandContext$.value == true && isDeviceisDesktop">Tickets</span>
                </a>
            </span>

            <!-- Page 'Store' - page d'accueuil quand non connecté -->
            <span
                [ngClass]="[
                    isStoreIconSelected && isDeviceisDesktop ? 'iconSelected' : '',
                    isStoreIconSelected && !isDeviceisDesktop ? 'mobileIconSelected' : '',
                ]"
                (click)="sendTo('store', 'store')"
                id="storeSpan"
            >
                <a>
                    <mat-icon class="navigationIcon storeIcon">store</mat-icon>
                    <span *ngIf="menuExpandContext$.value === true && isDeviceisDesktop"
                        >Store
                        <!-- <span id="newTag">Nouveau!</span> -->
                    </span>
                </a>
            </span>

            <!-- Version mobile -->
            <span
                *ngIf="!isDeviceisDesktop"
                [ngClass]="[isMoreIconSelected == true && isDeviceisDesktop == false ? 'mobileIconSelected' : '']"
                [matMenuTriggerFor]="menu"
            >
                <a>
                    <mat-icon>more_horiz</mat-icon>
                </a>
            </span>
            <mat-menu id="navigationMenu" #menu="matMenu">
                <!-- MARK: TimeLine dans menu mobile -->
                <span class="mobileLink" (click)="sendTo('timeline', 'timeline')">
                    <a>
                        <span class="material-icons-outlined navigationIcon">timeline</span>
                        <span>Planning</span>
                    </a>
                </span>
                <span class="mobileLink" (click)="sendTo('spots', 'spot')">
                    <a>
                        <span class="material-icons-outlined navigationIcon">play_circle_outline</span>
                        <span>Spots</span>
                    </a>
                </span>
                <!-- <span
                    class="mobileLink"
                    *ngIf="userService.hasRight('CanSeeLibrary')"
                    (click)="sendTo('medias', 'media')"
                >
                    <a>
                        <span class="material-icons-outlined navigationIcon">collections</span>
                        <span>Médiathèque</span>
                    </a>
                </span> -->

                <span
                    class="mobileLink"
                    *ngIf="userService.hasRight('CanSeeTicketOnScreen')"
                    (click)="sendTo('tickets', 'ticket')"
                >
                    <a>
                        <span class="material-icons-outlined navigationIcon">build</span>
                        <span>Tickets</span>
                    </a>
                </span>
                <span
                    class="mobileLink"
                    (click)="userService.isLogged() ? sendTo('account-detail', 'account') : logIn()"
                >
                    <a>
                        <mat-icon class="navigationIcon">account_circle</mat-icon>
                        <span>
                            {{ userService.isLogged() ? 'Compte' : 'Se Connecter' }}
                        </span>
                    </a>
                </span>
            </mat-menu>
        </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content
        [ngClass]="[
            isDeviceisDesktop ? 'mainContentSidenav' : 'mobileMainContentSidenav',
            menuExpandContext$.getValue() == false && menuContext$.getValue() == true
                ? 'fullWidthMainContentSidenav'
                : '',
        ]"
    >
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
